// Store original slide templates
const SPECIAL_OFFERS_TEMPLATES = {};
let templatesStored = false;
let isInitializing = false;
let swiperInstance = null;

// Wait for Swiper library to load (non-fatal)
function waitForSwiper(timeout = 5000) {
  return new Promise((resolve) => {
    if (typeof Swiper !== 'undefined') {
      resolve(true);
      return;
    }

    const checkInterval = setInterval(() => {
      if (typeof Swiper !== 'undefined') {
        clearInterval(checkInterval);
        resolve(true);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(checkInterval);
      resolve(false); // silent fail
    }, timeout);
  });
}

// Helper function to wait for element to exist
function waitForElement(selector, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const element = document.querySelector(selector);
    if (element) {
      resolve(element);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const element = document.querySelector(selector);
      if (element) {
        obs.disconnect();
        resolve(element);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(() => {
      observer.disconnect();
      reject();
    }, timeout);
  });
}

// Main initialization function
async function initializeSpecialOffers() {
  if (isInitializing) return;
  isInitializing = true;
  
  try {
    // Stop if section or slider not on page
    if (!document.querySelector('[data-cart-special-section]')) return;
    if (!document.querySelector('[data-special-slider]')) return;

    // Wait for Swiper (silent)
    const swiperLoaded = await waitForSwiper();
    if (!swiperLoaded) return;

    // Wait for track element
    await waitForElement('[data-special-track]');
    
    // Store templates
    storeOriginalSlides();
    
    // Refresh offers
    await refreshSpecialOffers();
    
    // Initialize slider
    initSpecialOffersSlider();
    
    // Initialize close button
    initCloseButton();
    
    // Hide loader
    hideSpecialOffersLoading();
    
  } catch (_) {
    hideSpecialOffersLoading();
  } finally {
    isInitializing = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  showSpecialOffersLoading();
  initializeSpecialOffers();

  // Cart interaction listeners
  document.body.addEventListener('click', (e) => {
    if (
      e.target.matches('[data-remove-item], .cart__remove, .quantity__button') ||
      e.target.closest('[data-remove-item], .cart__remove, .quantity__button')
    ) {
      setTimeout(() => {
        showSpecialOffersLoading();
        refreshSpecialOffers().then(() => {
          initSpecialOffersSlider();
          initCloseButton();
          hideSpecialOffersLoading();
        });
      }, 600);
    }
  });

  document.addEventListener('cart:updated', () => {
    setTimeout(() => {
      showSpecialOffersLoading();
      refreshSpecialOffers().then(() => {
        initSpecialOffersSlider();
        initCloseButton();
        hideSpecialOffersLoading();
      });
    }, 200);
  });
  
  document.addEventListener('cart:refresh', () => {
    setTimeout(() => {
      showSpecialOffersLoading();
      refreshSpecialOffers().then(() => {
        initSpecialOffersSlider();
        initCloseButton();
        hideSpecialOffersLoading();
      });
    }, 200);
  });
  
  document.addEventListener('cart-drawer:updated', () => {
    showSpecialOffersLoading();
    refreshSpecialOffers().then(() => {
      initSpecialOffersSlider();
      initCloseButton();
      hideSpecialOffersLoading();
    });
  });

  // Add to cart handler
  document.addEventListener('click', async (e) => {
    const atcBtn = e.target.closest('.special-offer-atc-btn');
    if (!atcBtn || atcBtn.disabled || atcBtn.classList.contains('adding')) return;

    e.preventDefault();
    
    const variantId = atcBtn.dataset.variantId;
    const productTitle = atcBtn.dataset.productTitle;
    const btnText = atcBtn.querySelector('.atc-btn-text');
    const btnLoading = atcBtn.querySelector('.atc-btn-loading');

    try {
      atcBtn.classList.add('adding');
      btnText.style.display = 'none';
      btnLoading.style.display = 'inline-flex';

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 2,
            properties: {
              "Total metres:": "1.0 metre",
            }
          }]
        })
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      const data = await response.json();

      atcBtn.classList.remove('adding');
      atcBtn.classList.add('success');
      btnText.textContent = 'ADDED!';
      btnText.style.display = 'inline';
      btnLoading.style.display = 'none';

      refreshCartDrawer();

      setTimeout(() => {
        atcBtn.classList.remove('success');
        btnText.textContent = 'ADD TO CART';
      }, 1500);

    } catch (_) {
      atcBtn.classList.remove('adding');
      btnText.textContent = 'ADD TO CART';
      btnText.style.display = 'inline';
      btnLoading.style.display = 'none';
    }
  });
});

// Function to initialize close button
function initCloseButton() {
  const closeButton = document.querySelector('.cart-special-offers-close');
  const specialOffersSection = document.querySelector('[data-cart-special-section]');
  if (!closeButton || !specialOffersSection) return;
  
  const newCloseButton = closeButton.cloneNode(true);
  closeButton.parentNode.replaceChild(newCloseButton, closeButton);
  
  newCloseButton.addEventListener('click', function() {
    specialOffersSection.style.opacity = '0';
    specialOffersSection.style.transition = 'opacity 0.3s ease';
    
    setTimeout(function() {
      specialOffersSection.style.display = 'none';
    }, 300);
    
    sessionStorage.setItem('specialOffersClosed', 'true');
  });
  
  if (sessionStorage.getItem('specialOffersClosed') === 'true') {
    specialOffersSection.style.display = 'none';
  }
}

function showSpecialOffersLoading() {
  const specialSection = document.querySelector('[data-cart-special-section]');
  if (specialSection) specialSection.classList.add('loading');
}

function hideSpecialOffersLoading() {
  const specialSection = document.querySelector('[data-cart-special-section]');
  if (specialSection) specialSection.classList.remove('loading');
}

function storeOriginalSlides() {
  if (templatesStored && Object.keys(SPECIAL_OFFERS_TEMPLATES).length > 0) return;

  const slides = document.querySelectorAll('.special-offer-slide');
  if (!slides.length) return;

  slides.forEach(slide => {
    const productId = slide.dataset.productId;
    if (productId && !SPECIAL_OFFERS_TEMPLATES[productId]) {
      SPECIAL_OFFERS_TEMPLATES[productId] = slide.cloneNode(true);
    }
  });

  templatesStored = true;
}

function refreshCartDrawer() {
  showSpecialOffersLoading();
  
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      fetch('/cart?view=drawer')
        .then(res => res.text())
        .then(html => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.classList.remove('is-empty');
          if (cartDrawer) {
            const parser = new DOMParser();
            const newDoc = parser.parseFromString(html, 'text/html');
            const newDrawerContent = newDoc.querySelector('cart-drawer');
            if (newDrawerContent) cartDrawer.innerHTML = newDrawerContent.innerHTML;
          }

          setTimeout(() => {
            refreshSpecialOffers().then(() => {
              initSpecialOffersSlider();
              initCloseButton();
              hideSpecialOffersLoading();
            });
          }, 300);
        });

      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: cart }));
    })
    .catch(() => hideSpecialOffersLoading());
}

function initSpecialOffersSlider() {
  if (typeof Swiper === 'undefined') return;

  const slider = document.querySelector('[data-special-slider]');
  const track = document.querySelector('[data-special-track]');
  if (!slider || !track) return;

  const slides = Array.from(track.querySelectorAll('.special-offer-slide'));
  if (slides.length === 0) return;

  if (swiperInstance) {
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }

  swiperInstance = new Swiper('[data-special-slider]', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    pagination: {
      el: '[data-special-dots]',
      clickable: true,
    },
    speed: 400,
    touchRatio: 1,
    touchAngle: 45,
    grabCursor: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
    },
    effect: 'slide',
  });
}

async function refreshSpecialOffers() {
  const specialSection = document.querySelector('[data-cart-special-section]');
  const track = document.querySelector('[data-special-track]');
  if (!specialSection || !track) return;

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    if (cart.item_count === 0) {
      specialSection.style.display = 'none';
      return;
    }

    const cartProductIds = new Set(cart.items.map(item => item.product_id.toString()));
    track.innerHTML = '';

    Object.keys(SPECIAL_OFFERS_TEMPLATES).forEach(productId => {
      if (!cartProductIds.has(productId)) {
        const slideTemplate = SPECIAL_OFFERS_TEMPLATES[productId].cloneNode(true);
        track.appendChild(slideTemplate);
      }
    });

    const remainingSlides = track.querySelectorAll('.special-offer-slide');
    if (remainingSlides.length === 0) {
      specialSection.style.display = 'none';
    } else if (sessionStorage.getItem('specialOffersClosed') !== 'true') {
      specialSection.style.display = 'block';
      specialSection.style.opacity = '1';
    }

  } catch (_) {}
}

// Search price doubler
(function () {
  const SEARCH_INPUT_SELECTOR = '.m-form-search input[type="search"]';
  const PRICE_SELECTORS = [
    '.snize-ac-results .snize-product-tag-metre span.snize-price.money',
    '.snize-search-results-main-content .snize-product-tag-metre .snize-price-list span.snize-price.money',
    '.snize-ac-results .snize-product-tag-metre span.snize-discounted-price.money',
    '.snize-search-results-main-content .snize-product-tag-metre .snize-price-list span.snize-discounted-price.money'
    
  ];

  function updatePrices() {
    PRICE_SELECTORS.forEach(selector => {
      const prices = document.querySelectorAll(selector);
      prices.forEach(priceEl => {
        if (priceEl.dataset.doubled === 'true') return;

        const text = priceEl.textContent.trim();
        const match = text.match(/([€£$])?\s?([\d,.]+)/);
        if (!match) return;

        const currency = match[1] || '$';
        const price = parseFloat(match[2].replace(/,/g, ''));
        if (isNaN(price)) return;

        priceEl.textContent = `${currency}${(price * 2).toFixed(2)}`;
        priceEl.dataset.doubled = 'true';
      });
    });
  }

  document.addEventListener('input', function (e) {
    if (e.target.matches(SEARCH_INPUT_SELECTOR)) {
      setTimeout(updatePrices, 300);
    }
  });

  const observer = new MutationObserver(() => {
    updatePrices();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();









// Start Cart Drawer JS

(function () {
  const METER_PER_UNIT = 0.5;
  let isUpdating = false;
  let observer;
  let updateQueue = [];
  let isProcessingQueue = false;

  function updateAllMeterDisplays() {
  if (isUpdating) return;
  isUpdating = true;

  document.querySelectorAll('.m-cart-item').forEach(cartItem => {
    // 1. Identify the container
    const metreContainer = cartItem.querySelector('.item-tag-metre, .item-tag-halfmetre') ||
                           (cartItem.classList.contains('item-tag-metre') || cartItem.classList.contains('item-tag-halfmetre') ? cartItem : null);

    // 2. IMPORTANT: If this isn't a metre product, STOP immediately for this item
    if (!metreContainer) return; 

    const qtyInput = cartItem.querySelector('.m-quantity__input[data-index]');
    const meterValueEl = metreContainer.querySelector('[data-cart-item-property-value]');

    // 3. Double check: if there is no place to show the value, don't process it
    if (!qtyInput || !meterValueEl) return;

    const isHalfMetre = metreContainer.classList.contains('item-tag-halfmetre');
    const minQty = isHalfMetre ? 1 : 2;
    const line = parseInt(qtyInput.dataset.index, 10);
    const qty = Math.max(minQty, parseInt(qtyInput.value, 10) || minQty);

    let totalMetres = qty * METER_PER_UNIT;
    totalMetres = Math.round(totalMetres * 2) / 2;
    const newText = `${totalMetres} ${totalMetres === 1 ? 'metre' : 'metres'}`;

    if (meterValueEl.textContent.trim() !== newText) {
      meterValueEl.textContent = newText;
      // 4. Only queue if it's confirmed to be a metre product
      addToQueue(line, qty, totalMetres);
    }
  });

  isUpdating = false;
}

  // ✅ Add update to queue (avoid duplicates for same line)
  function addToQueue(line, quantity, totalMetres) {
    // Remove existing update for this line
    updateQueue = updateQueue.filter(item => item.line !== line);
    
    // Add new update
    updateQueue.push({ line, quantity, totalMetres });
    
    // Start processing if not already running
    if (!isProcessingQueue) {
      processQueue();
    }
  }

  // ✅ Process queue one at a time with delays
  async function processQueue() {
    if (isProcessingQueue || updateQueue.length === 0) return;
    
    isProcessingQueue = true;

    while (updateQueue.length > 0) {
      const update = updateQueue.shift();
      await syncCheckoutProperty(update.line, update.quantity, update.totalMetres);
      
      // ✅ Wait between updates to avoid conflicts
      if (updateQueue.length > 0) {
        await sleep(500); // 500ms delay between each cart update
      }
    }

    isProcessingQueue = false;
  }

  // ✅ Helper function for delays
  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // ✅ Update cart with both quantity and property
  async function syncCheckoutProperty(line, quantity, totalMetres) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          properties: {
            'Total Metre': `${totalMetres} ${totalMetres === 1 ? 'metre' : 'metres'}`
          }
        })
      });
      
      const cart = await response.json();
      console.log(`✅ Line ${line} updated: ${quantity} units = ${totalMetres} metres`);
      return cart;
    } catch (error) {
      console.error(`❌ Error updating line ${line}:`, error);
      return null;
    }
  }

  // ✅ Handle quantity changes
  function handleQuantityChange(target) {
    const cartItem = target.closest('.m-cart-item');
    if (!cartItem) return;

    // ✅ Check both structures
    // const metreContainer = cartItem.querySelector('.item-tag-metre') || 
    //                       (cartItem.classList.contains('item-tag-metre') ? cartItem : null);

    const metreContainer =
    cartItem.querySelector('.item-tag-metre, .item-tag-halfmetre') ||
    (cartItem.classList.contains('item-tag-metre') ||
    cartItem.classList.contains('item-tag-halfmetre')
      ? cartItem
      : null);

  if (!metreContainer) return; // 👈 normal product → exit safely

  const isHalfMetre = metreContainer.classList.contains('item-tag-halfmetre');
  const minQty = isHalfMetre ? 1 : 2;


    const qtyInput = cartItem.querySelector('.m-quantity__input[data-index]');
    if (!qtyInput) return;

    const line = parseInt(qtyInput.dataset.index, 10);
    const qty = Math.max(minQty, parseInt(qtyInput.value, 10) || minQty);
    
    let totalMetres = qty * METER_PER_UNIT;
    totalMetres = Math.round(totalMetres * 2) / 2;

    // Update display immediately
    const meterValueEl = metreContainer.querySelector('[data-cart-item-property-value]');
    if (meterValueEl) {
      const newText = `${totalMetres} ${totalMetres === 1 ? 'metre' : 'metres'}`;
      meterValueEl.textContent = newText;
    }

    // ✅ Add to queue for processing
    addToQueue(line, qty, totalMetres);
  }

  // Plus / minus buttons
  document.addEventListener('click', e => {
    const button = e.target.closest('.m-quantity__button');
    if (button) {
      setTimeout(() => {
        handleQuantityChange(button);
      }, 150);
    }
  });

  // Manual input change
  document.addEventListener('change', e => {
    if (e.target.matches('.m-quantity__input')) {
      handleQuantityChange(e.target);
    }
  });

  // ✅ Real-time display update while typing
  document.addEventListener('input', e => {
    if (e.target.matches('.m-quantity__input')) {
      const cartItem = e.target.closest('.m-cart-item');
      if (!cartItem) return;

      const metreContainer =
      cartItem.querySelector('.item-tag-metre, .item-tag-halfmetre') ||
      (cartItem.classList.contains('item-tag-metre') ||
      cartItem.classList.contains('item-tag-halfmetre')
        ? cartItem
        : null);

    if (!metreContainer) return; // 👈 normal product → exit safely

    const isHalfMetre = metreContainer.classList.contains('item-tag-halfmetre');
    const minQty = isHalfMetre ? 1 : 2;


      const qty = Math.max(minQty, parseInt(e.target.value, 10) || minQty);
      let totalMetres = qty * METER_PER_UNIT;
      totalMetres = Math.round(totalMetres * 2) / 2;
      
      const meterValueEl = metreContainer.querySelector('[data-cart-item-property-value]');
      if (meterValueEl) {
        const newText = `${totalMetres} ${totalMetres === 1 ? 'metre' : 'metres'}`;
        meterValueEl.textContent = newText;
      }
    }
  });

  // Observe drawer + cart page
  function initObserver() {
    if (observer) observer.disconnect();

    observer = new MutationObserver(mutations => {
      const shouldUpdate = mutations.some(m =>
        [...m.addedNodes].some(n =>
          n.nodeType === 1 && n.classList?.contains('m-cart-item')
        )
      );
      if (shouldUpdate) setTimeout(updateAllMeterDisplays, 200);
    });

    ['.m-cart__items', '.m-cart-drawer__items'].forEach(sel => {
      const el = document.querySelector(sel);
      if (el) observer.observe(el, { childList: true });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateAllMeterDisplays();
    initObserver();
  });

  document.addEventListener('cart:updated', updateAllMeterDisplays);
  document.addEventListener('shopify:cart:update', updateAllMeterDisplays);
})();

// End Cart Drawer JS








// Start Cart Quantity Message


(function () {
  const CART_ROOT = document.body;

  // Handle input & change (covers all cases)
  function handleQuantityInput(e) {
    const input = e.target;
    if (!input.classList.contains('m-quantity__input')) return;

    if (input.value.includes('.')) {
      input.value = Math.floor(input.value);
      showMessage(input, 'Incorrect Measurement/Quantity. Whole Numbers Only.');
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Event delegation (works for AJAX content)
  CART_ROOT.addEventListener('input', handleQuantityInput);
  CART_ROOT.addEventListener('change', handleQuantityInput);

  // Observe cart re-renders (drawer + page)
  const observer = new MutationObserver(() => {
    document
      .querySelectorAll('.m-quantity__input')
      .forEach(input => {
        input.dataset.decimalCheckAttached = 'true';
      });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Message UI
  function showMessage(inputEl, text) {
    const wrapper = inputEl.closest('.m-quantity');
    if (!wrapper) return;

    let msgBox = wrapper.querySelector('.quantity-error-msg');

    if (!msgBox) {
      msgBox = document.createElement('div');
      msgBox.className = 'quantity-error-msg';
      msgBox.style.cssText = `
        position: absolute;
        bottom: -18px;
        left: 0;
        color: red;
        font-size: 12px;
        font-weight: 500;
        text-align: left;
      `;
      wrapper.style.position = 'relative';
      wrapper.appendChild(msgBox);
    }

    msgBox.textContent = text;
    msgBox.style.display = 'block';

    clearTimeout(msgBox._timer);
    msgBox._timer = setTimeout(() => {
      msgBox.style.display = 'none';
    }, 2000);
  }
})();

// End Cart Quantity Message






// Start minimum quantity 1 on cart page and cart drawer

// document.addEventListener('DOMContentLoaded', () => {
//   function enforceMetreMinQuantity() {
//     // Select all cart drawer and cart page items with the tag-metre class
//     const metreItems = document.querySelectorAll('.m-cart-item.item-tag-metre, .m-cart__column .item-tag-metre');

//     metreItems.forEach(item => {
//       const input = item.querySelector('.m-quantity__input');
//       if (!input) return;

//       // Only update if current value is less than 2
//       if (parseInt(input.value) < 2 || isNaN(parseInt(input.value))) {
//         input.value = 2;
//       }

//       // Set min attribute to 2 (won't block higher numbers)
//       input.min = 2;
//     });
//   }

//   // Initial enforcement
//   enforceMetreMinQuantity();

//   // Observe changes in cart (like AJAX updates)
//   const observer = new MutationObserver(() => {
//     enforceMetreMinQuantity();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// });



// (function () {
//   const MIN_QTY = 2;

//   function enforceMetreMinQuantity(root = document) {
//     const metreInfoBlocks = root.querySelectorAll('.item-tag-metre');

//     metreInfoBlocks.forEach(infoBlock => {
//       // Find the closest cart item (works for cart + drawer)
//       const cartItem = infoBlock.closest('.m-cart-item');
//       if (!cartItem) return;

//       const input = cartItem.querySelector('.m-quantity__input');
//       if (!input) return;

//       let value = parseInt(input.value, 10);

//       if (isNaN(value) || value < MIN_QTY) {
//         input.value = MIN_QTY;
//         input.dispatchEvent(new Event('change', { bubbles: true }));
//       }

//       input.min = MIN_QTY;
//     });
//   }

//   // Initial load
//   document.addEventListener('DOMContentLoaded', () => {
//     enforceMetreMinQuantity();
//   });

//   // Watch for AJAX cart updates (Minimog replaces DOM)
//   const observer = new MutationObserver(mutations => {
//     mutations.forEach(mutation => {
//       mutation.addedNodes.forEach(node => {
//         if (node.nodeType === 1) {
//           enforceMetreMinQuantity(node);
//         }
//       });
//     });
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

//   // Manual input protection
//   document.addEventListener('change', e => {
//     if (!e.target.classList.contains('m-quantity__input')) return;

//     const cartItem = e.target.closest('.m-cart-item');
//     if (!cartItem) return;

//     if (cartItem.querySelector('.item-tag-metre')) {
//       if (parseInt(e.target.value, 10) < MIN_QTY) {
//         e.target.value = MIN_QTY;
//         e.target.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//     }
//   });
// })();



(function () {
  const MIN_QTY = 2;

  function isMetreItem(cartItem) {
    return (
      cartItem.classList.contains('item-tag-metre') ||
      cartItem.querySelector('.item-tag-metre')
    );
  }

  function enforceMetreMinQuantity(root = document) {
    root.querySelectorAll('.m-cart-item').forEach(cartItem => {
      if (!isMetreItem(cartItem)) return;

      const input = cartItem.querySelector('.m-quantity__input');
      if (!input) return;

      let value = parseInt(input.value, 10);

      if (isNaN(value) || value < MIN_QTY) {
        input.value = MIN_QTY;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      input.min = MIN_QTY;
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    enforceMetreMinQuantity();
  });

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          enforceMetreMinQuantity(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('change', e => {
    if (!e.target.classList.contains('m-quantity__input')) return;

    const cartItem = e.target.closest('.m-cart-item');
    if (!cartItem) return;

    if (isMetreItem(cartItem)) {
      if (parseInt(e.target.value, 10) < MIN_QTY) {
        e.target.value = MIN_QTY;
        e.target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
})();

// End minimum quantity 1 on cart page and cart drawer


// Start Sample Product - Remove properties and variant option

(function () {
  // ✅ Configuration
  const EXCLUDED_PRODUCTS = ['/products/samples'];
  
  // ✅ Exact property names to remove from checkout
  const PROPERTIES_TO_REMOVE = [
    'Sample of tag',
    'Vendor',
    'Sample of tag: Metre',
    'Total metres',
    'Total Metre'
  ];

  // ✅ Property class names to hide in cart UI
  const PROPERTY_CLASSES_TO_HIDE = [
    '.cart-item-total-metres',
    '.m-cart-item__option' // This is for "Sample of tag: Metre" and variant options
  ];

  // ✅ Check if product should be excluded
  function isExcludedProduct(cartItem) {
    const productLink = cartItem.querySelector('a[href*="/products/"]');
    if (productLink) {
      const href = productLink.getAttribute('href');
      return EXCLUDED_PRODUCTS.some(url => href.includes(url));
    }
    
    const productUrl = cartItem.dataset.productUrl || cartItem.dataset.url;
    if (productUrl) {
      return EXCLUDED_PRODUCTS.some(url => productUrl.includes(url));
    }
    
    return false;
  }

  // ✅ Hide excluded properties and variant options from display in cart
  function hideExcludedProperties(cartItem) {
    // Hide by specific class names
    PROPERTY_CLASSES_TO_HIDE.forEach(className => {
      const elements = cartItem.querySelectorAll(className);
      elements.forEach(el => {
        el.style.display = 'none';
      });
    });

    // Hide ALL variant options (Title, Size, Color options, etc.)
    const options = cartItem.querySelectorAll('.m-cart-item__option');
    options.forEach(el => {
      el.style.display = 'none';
    });

    // Hide the metre tag container if it exists
    const metreContainer = cartItem.querySelector('.item-tag-metre');
    if (metreContainer) {
      metreContainer.style.display = 'none';
    }
    
    // Hide the vendor container if it exists
    const vendorContainer = cartItem.querySelector('.cart-item-vendor');
    if (vendorContainer) {
      vendorContainer.style.display = 'none';
    }
  }

  // ✅ Get current cart and filter properties
  async function removePropertiesFromCart(line) {
    try {
      // First, get the current cart to see existing properties
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Find the item by line number (line is 1-indexed)
      const item = cart.items[line - 1];
      if (!item) {
        console.log('❌ Item not found at line', line);
        return;
      }

      // Get current properties
      const currentProperties = item.properties || {};
      
      console.log('📋 Current properties for line', line, ':', currentProperties);
      
      // Create new properties object, keeping only the ones we want
      const newProperties = {};
      Object.keys(currentProperties).forEach(key => {
        // Check if this exact property should be removed
        const shouldRemove = PROPERTIES_TO_REMOVE.some(prop => key === prop);
        
        if (!shouldRemove) {
          newProperties[key] = currentProperties[key];
          console.log('✅ Keeping property:', key, '=', currentProperties[key]);
        } else {
          console.log('❌ Removing property:', key);
        }
      });

      console.log('📦 New properties to save:', newProperties);

      // Update cart with filtered properties
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: item.quantity,
          properties: newProperties
        })
      });
      
      const updatedCart = await response.json();
      console.log(`✅ Updated cart for line ${line}`);
      console.log('Final properties at checkout:', updatedCart.items[line - 1].properties);
      return updatedCart;
    } catch (error) {
      console.error(`❌ Error filtering properties:`, error);
      return null;
    }
  }


  // ✅ Process all cart items
  async function processCartItems() {
    console.log('🔄 Processing cart items...');
    const cartItems = document.querySelectorAll('.m-cart-item');
    
    for (const cartItem of cartItems) {
      if (isExcludedProduct(cartItem)) {
        console.log('🎯 Found samples product, processing...');
        
        // Hide properties and variant options in UI immediately
        hideExcludedProperties(cartItem);
        
        // Remove from cart/checkout
        const qtyInput = cartItem.querySelector('.m-quantity__input[data-index]');
        if (qtyInput) {
          const line = parseInt(qtyInput.dataset.index, 10);
          if (line) {
            await removePropertiesFromCart(line);
            // Wait before processing next item
            await new Promise(resolve => setTimeout(resolve, 400));
          }
        }
      }
    }
  }

  // ✅ Observe cart changes
  let observer;
  function initObserver() {
    if (observer) observer.disconnect();

    observer = new MutationObserver(() => {
      setTimeout(processCartItems, 500);
    });

    ['.m-cart__items', '.m-cart-drawer__items', '.m-cart-drawer-item__variant'].forEach(sel => {
      const el = document.querySelector(sel);
      if (el) observer.observe(el, { childList: true, subtree: true });
    });
  }

  // ✅ Initialize
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(processCartItems, 800);
    initObserver();
  });

  document.addEventListener('cart:updated', () => {
    setTimeout(processCartItems, 500);
  });
  
  document.addEventListener('shopify:cart:update', () => {
    setTimeout(processCartItems, 500);
  });

  // ✅ Also run when cart drawer opens
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-drawer-toggle], .m-cart-drawer-toggle')) {
      setTimeout(processCartItems, 600);
    }
  });

  // ✅ DEBUG: Check cart properties
  window.debugSamplesCart = async function() {
    const cart = await fetch('/cart.js').then(r => r.json());
    console.log('🛒 Full cart:', cart);
    cart.items.forEach((item, index) => {
      console.log(`Item ${index + 1}:`, item.product_title);
      console.log('Variant title:', item.variant_title);
      console.log('Properties:', item.properties);
    });
  };
  
  console.log('💡 Run debugSamplesCart() in console to see current cart properties');
})();

 // End Sample Product - Remove properties and variant option


// Start Price update on variant change

// =============================================
// HELPERS
// =============================================
function formatMoney(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

function applyDiscount(price, discountPercent) {
  if (!discountPercent || discountPercent <= 0) return price;
  return Math.round(price - (price * discountPercent) / 100);
}

// =============================================
// PDP PRICE (DOUBLE PRICE LOGIC)
// =============================================
function updateDoubleVariantPrice(variant) {
  console.log('🔄 updateDoubleVariantPrice called', variant);
  
  if (!variant) {
    console.warn('⚠️ No variant provided');
    return;
  }

  const price = variant.price * 2;
  const compareAtPrice = variant.compare_at_price
    ? variant.compare_at_price * 2
    : null;

  console.log('Price (doubled):', formatMoney(price));
  console.log('Compare price (doubled):', compareAtPrice ? formatMoney(compareAtPrice) : 'none');

  // Try multiple selectors for the price container
  const priceContainer = document.querySelector('.bulk-product-pricing') || 
                         document.querySelector('.m-price');
  
  if (!priceContainer) {
    console.error('❌ Price container not found');
    return;
  }

  // Get sale and regular price wrappers
  const salePriceWrapper = priceContainer.querySelector('.m-price__sale');
  const regularPriceWrapper = priceContainer.querySelector('.m-price__regular');
  
  console.log('Sale wrapper found:', !!salePriceWrapper);
  console.log('Regular wrapper found:', !!regularPriceWrapper);

  // Sale price element (in .m-price__sale)
  const salePriceEl = salePriceWrapper?.querySelector('[data-price] .money');
  
  // Regular price element (in .m-price__regular)
  const regularPriceEl = regularPriceWrapper?.querySelector('.m-price-item--regular .money');
  
  // Compare price element
  const comparePriceContainer = salePriceWrapper?.querySelector('[data-compare-price]');
  const comparePriceEl = comparePriceContainer?.querySelector('.money');

  console.log('Sale price element:', !!salePriceEl);
  console.log('Regular price element:', !!regularPriceEl);
  console.log('Compare price element:', !!comparePriceEl);

  // Update based on whether product is on sale
  if (compareAtPrice && compareAtPrice > price) {
    console.log('🏷️ Product is ON SALE');
    
    // Show sale price
    if (salePriceEl) {
      salePriceEl.textContent = formatMoney(price);
      console.log('✅ Sale price updated');
    }
    
    // Show compare-at price
    if (comparePriceEl) {
      comparePriceEl.textContent = formatMoney(compareAtPrice);
      console.log('✅ Compare price updated');
    }
    
    // Show compare price container
    if (comparePriceContainer) {
      comparePriceContainer.classList.remove('m:hidden');
    }
    
    // Add sale class to main container
    priceContainer.classList.add('m-price--on-sale');
    
  } else {
    console.log('💰 Product is REGULAR PRICE');
    
    // Update both sale and regular price elements with same price
    if (salePriceEl) {
      salePriceEl.textContent = formatMoney(price);
    }
    if (regularPriceEl) {
      regularPriceEl.textContent = formatMoney(price);
    }
    
    // Hide compare price
    if (comparePriceContainer) {
      comparePriceContainer.classList.add('m:hidden');
    }
    
    // Remove sale class
    priceContainer.classList.remove('m-price--on-sale');
  }
  
  console.log('✅ Price update complete');
}

// =============================================
// BULK PRICING – TIER PRICES WITH DISCOUNT
// =============================================
function updateBulkTierPrices(variant) {
  console.log('🔄 updateBulkTierPrices called', variant);
  
  if (!variant) {
    console.warn('⚠️ No variant provided');
    return;
  }

  const tierEls = document.querySelectorAll(
    '.bulk-pricing-calculator__tier'
  );

  console.log('Tier elements found:', tierEls.length);

  if (!tierEls.length) return;

  // Prefer compare_at_price, fallback to price

  // const basePrice = variant.compare_at_price || variant.price;

  const basePrice = variant.price;

  // Per metre (DOUBLE LOGIC)
  const perMeterBasePrice = basePrice * 2;
  
  console.log('Base price per meter (doubled):', formatMoney(perMeterBasePrice));

  tierEls.forEach((tierEl, index) => {
    const discount = parseFloat(tierEl.dataset.discount) || 0;
    const priceEl = tierEl.querySelector(
      '.bulk-pricing-calculator__tier-price'
    );

    if (!priceEl) {
      console.warn(`⚠️ Price element not found for tier ${index}`);
      return;
    }

    const discountedPrice = applyDiscount(
      perMeterBasePrice,
      discount
    );

    console.log(`Tier ${index + 1}: ${discount}% off = ${formatMoney(discountedPrice)}/m`);

    priceEl.textContent = `${formatMoney(discountedPrice)}/m`;
  });
  
  console.log('✅ Bulk tier prices updated');
}

// =============================================
// ON PAGE LOAD
// =============================================
document.addEventListener('DOMContentLoaded', function () {
  console.log('=== PAGE LOADED ===');
  
  const variantEl = document.querySelector(
    '.metre-based-product variant-picker [data-selected-variant]'
  );

  if (!variantEl) {
    console.error('❌ variant-picker element not found');
    return;
  }

  const variant = JSON.parse(variantEl.textContent);

  console.log('ON LOAD → Variant ID:', variant.id);
  console.log('ON LOAD → Original Price:', variant.price / 100);
  console.log('ON LOAD → Double Price:', (variant.price * 2) / 100);
  console.log('ON LOAD → Compare Price:', variant.compare_at_price ? (variant.compare_at_price * 2) / 100 : 'none');

  updateDoubleVariantPrice(variant);
  updateBulkTierPrices(variant);
});

// =============================================
// ON VARIANT CHANGE
// =============================================
document.addEventListener('variant:changed', function (e) {
  console.log('=== VARIANT CHANGED ===');
  
  const variant = e.detail.variant;
  
  if (!variant) {
    console.warn('⚠️ No variant in event');
    return;
  }

  console.log('ON CHANGE → Variant ID:', variant.id);
  console.log('ON CHANGE → Original Price:', variant.price / 100);
  console.log('ON CHANGE → Double Price:', (variant.price * 2) / 100);
  console.log('ON CHANGE → Compare Price:', variant.compare_at_price ? (variant.compare_at_price * 2) / 100 : 'none');

  updateDoubleVariantPrice(variant);
  updateBulkTierPrices(variant);
});

console.log('=== PRICE SCRIPT LOADED ===');


// End Price update on variant change